module.exports = {
    unixToDatetime: function (unix, dateOnly) {
        if (unix < 9e9) {
            unix *= 1000;
        }
        var d = new Date(unix),
            year = d.getFullYear(),
            month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1,
            // month = d.getMonth() + 1,
            date = d.getDate() < 10 ? '0' + d.getDate() : d.getDate(),
            hour = d.getHours(),
            minute = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes(),
            // minute = d.getMinutes(),
            second = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();
            // second = d.getSeconds();
        if (dateOnly) {
            return year + "-" + month + "-" + date;
        }
        return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
    },
    getLastDays: function (days) {
        var date = new Date();
        var last = new Date(date.getTime() - (days * 24 * 60 * 60 * 1000));
        var day = last.getDate();
        var month = last.getMonth() + 1;
        var year = last.getFullYear();
        return year + '-' + month + '-' + day;
    },
    formatDate: function (date) {
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    },
    ajaxErrorFunc: function(xhr) {
        var message = '页面出错或者登录失效，刷新后请重试一次';
        var that = this;
        if(typeof xhr.responseJSON.message != 'undefined') {
            message = xhr.responseJSON.message;
        } else if(typeof xhr.responseJSON.msg != 'undefined') {
            message = xhr.responseJSON.msg;
        }
        that.alert(message, function() {
            location.reload();
        });
    },
    // v1.3.0 新增统一弹窗
    alert: function(opt, callback) {
        this.popHtml("alert", opt);
        this.popOk(callback);   //alert只是弹出消息，因此没必要用到回调函数callback
        this.popCancel(callback);
    },
    confirm: function(opt, callback) {
        this.popHtml("confirm", opt);
        this.popOk(callback);
        this.popCancel();
    },
    popHtml: function(type, opt) {
        var html = '',
            _opt = { // 默认参数
                id: false,
                class: false,
                cover: false,
                title: '提示',
                titleShow: false,
                msg: '',
                center: false
                // confirm: false,
                // closePro: false    //关闭需要使用回调函数时
            };        
        if(typeof opt == 'object') {
            $.extend(_opt, opt);
        }
        if(typeof opt == 'string') {
            _opt.msg = opt;
        }
        if(_opt.cover){
            html += '<div class="popup-cover"></div>'
        }
        html += '<div class="popup utils-popup'+ (_opt.class ? _opt.class : '') +'" '+ (_opt.id ? 'id="'+ _opt.id +'"' : '') +'>'
            + '<div class="popup-wrap">'
            +    '<span class="popup-close"><i class="popup-ico"></i></span>'
            +    '<div class="popup-hd">'+ (_opt.titleShow ? _opt.title : '') +'</div>'
            +    '<div class="popup-bd' + (_opt.center ? ' popup-center' : '') + '">'
            +        '<p>'+ _opt.msg +'</p>'
            +    '</div>'
            +    '<div class="popup-fd">'
            +        (type == "confirm" ? '<button class="popup-cancel">取消</button>' : '') + '<button class="popup-ok">确定</button>'
            +    '</div>'
            +'</div>'
        +'</div>';
                
        $('body').append(html);
    },
    popOk: function(callback) {
        $('.popup-ok').off('click').on('click', function() {
            $('.utils-popup, .popup-cover').remove();
            if(typeof callback == 'function') {            
                callback();
            }
        });
    },
    popCancel: function(callback) {
        $('.utils-popup').on('click', '.popup-cancel, .popup-close', function() {
            // $('.utils-popup, .popup-cover').fadeOut(100, function(){
            $('.utils-popup, .popup-cover').remove();
            if(typeof callback == 'function') {
                callback();
            }
        });
    }//,
    // pop: function(opt, callback, closeback) {
    //     let html = '',
    //         _callback = '',
    //         _opt = { // 默认参数
    //             id: false,
    //             class: false,
    //             cover: false,
    //             title: '提示',
    //             text: '',
    //             center: false,
    //             confirm: false,
    //             closePro: false    //关闭需要使用回调函数时
    //         };        
    //     if(typeof opt == 'object') {
    //         $.extend(_opt, opt);
    //     }
    //     if(typeof opt == 'string') {
    //         _opt.text = opt;
    //     }
    //     if(_opt.cover){
    //         html += '<div class="popup-cover"></div>'
    //     }
    //     html += '<div class="popup'+ (_opt.class ? _opt.class : '') +'"'+ (_opt.id ? 'id="'+ _opt.id +'"' : '') +'>'
    //         + '<div class="popup-wrap">'
    //         +    '<span class="popup-close"><i class="popup-ico"></i></span>'
    //         +    '<div class="popup-hd">'+ _opt.title +'</div>'
    //         +    '<div class="popup-bd' + (_opt.center ? ' popup-center' : '') + '">'
    //         +        '<p>'+ _opt.text +'</p>'
    //         +    '</div>'
    //         +    '<div class="popup-fd">'
    //         +        (_opt.confirm ? '<button class="popup-cancel">取消</button>' : '') + '<button class="popup-ok">确定</button>'
    //         +    '</div>'
    //         +'</div>'
    //     +'</div>';
                
    //     $('body').append(html);
    //     // if(typeof callback == 'function') {
    //     //     _callback = callback;
    //     // } else {
    //     //     _callback = function() {
    //     //         $('.popup, .popup-cover').fadeOut(100);
    //     //     }
    //     // }
    //     // $('body').on('click', '.popup-ok', _callback);
    //     // if(!_opt.confirm){
    //     //     $('body').on('click', '.popup-close', _callback);
    //     // }

    //     // 任何情况下，关闭、确定、取消都应该关闭弹窗和浮层
    //     $('body').on('click', '.popup-cancel, .popup-close, .popup-ok', function() {
    //         $('.popup, .popup-cover').fadeOut(100);
    //     });
    //     if(typeof callback == 'function') {
    //         $('body').off('click', '.popup-ok').on('click', '.popup-ok', callback);
    //         if(_opt.closePro) {
    //             $('body').off('click', '.popup-close').on('click', '.popup-close', callback);
    //         }
    //     }
    //     // close需要绑定额外不同于‘确定’按钮的事件时使用
    //     // 一般不与closePro一起使用，后期考虑增加互斥检查
    //     if(typeof closeback == 'function') {
    //         $('body').off('click', '.popup-close').on('click', '.popup-close', closeback);
    //     }
    // }
}